var _defs, _use, _use2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThunderstormsNight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "c",
    viewBox: "0 0 172 172"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    stroke: "#72b9d5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M160.6 107.4a84.8 84.8 0 01-85.4-84.3A83.3 83.3 0 0178 2 84.7 84.7 0 002 85.7 84.8 84.8 0 0087.4 170a85.2 85.2 0 0082.6-63.1 88 88 0 01-9.4.5Z"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    additive: "sum",
    attributeName: "transform",
    dur: "6s",
    repeatCount: "indefinite",
    type: "rotate",
    values: "-15 86 86; 9 86 86; -15 86 86"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "d",
    viewBox: "0 0 350 222"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    stroke: "#e6effc",
    strokeMiterlimit: 10,
    strokeWidth: 6,
    d: "m291 107-2.5.1A83.9 83.9 0 00135.6 43 56 56 0 0051 91a56.6 56.6 0 00.8 9A60 60 0 0063 219l4-.2v.2h224a56 56 0 000-112Z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "g",
    viewBox: "0 0 351 246"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    width: 172,
    height: 172
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    width: 350,
    height: 222,
    transform: "translate(1 24)"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "h",
    viewBox: "0 0 102.7 186.8"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    stroke: "#f6a823",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    d: "m34.8 2-32 96h32l-16 80 80-112h-48l32-64h-48z"
  }, /*#__PURE__*/React.createElement("animate", {
    id: "f",
    attributeName: "opacity",
    begin: "0s; f.end+.67s",
    dur: "1.33s",
    keyTimes: "0; .38; .5; .63; .75; .86; .94; 1",
    values: "1; 1; 0; 1; 0; 1; 0; 1"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 99.5,
    x2: 232.6,
    y1: 30.7,
    y2: 261.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f3f7fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f3f7fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#deeafb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 8.7,
    x2: 80.9,
    y1: 17.1,
    y2: 142.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7b23b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f7b23b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f59e0b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 34.7,
    x2: 119.2,
    y1: 18.6,
    y2: 165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#86c3db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#86c3db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5eafcf"
  })))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    width: 351,
    height: 246,
    transform: "translate(80 121)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h",
    width: 102.7,
    height: 186.7,
    transform: "translate(205.23 291)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThunderstormsNight);
export default __webpack_public_path__ + "static/media/thunderstorms-night.73eead4f36279cffe40ca8a45a6bce5b.svg";
export { ForwardRef as ReactComponent };